var AllForWeb;
(function (AllForWeb) {
    AllForWeb.UILanguage = 1030;
    console.log("CORE-JS");
    function getFormData(form) {
        var allData = new FormData(form);
        if (allData.has("__RequestVerificationToken"))
            allData.delete("__RequestVerificationToken");
        allData.append("__RequestVerificationToken", AllForWeb._afToken);
        return allData;
    }
    AllForWeb.getFormData = getFormData;
    function getFormDataOLD($form) {
        var o = {};
        $.each($form.serializeArray(), function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            }
            else {
                o[this.name] = this.value || '';
            }
        });
        if (('__RequestVerificationToken' in o) == true)
            o["__RequestVerificationToken"] = AllForWeb._afToken;
        return o;
    }
    AllForWeb.getFormDataOLD = getFormDataOLD;
    function addEventListenerList(list, event, fn) {
        for (var i = 0, len = list.length; i < len; i++) {
            list[i].addEventListener(event, fn, false);
        }
    }
    AllForWeb.addEventListenerList = addEventListenerList;
    var FormSubmit = (function () {
        function FormSubmit() {
            console.log("FormSubmit constructor.");
        }
        return FormSubmit;
    }());
    AllForWeb.FormSubmit = FormSubmit;
})(AllForWeb || (AllForWeb = {}));
//# sourceMappingURL=AllForWeb.Core.js.map